import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchFormRecords } from './translations.action';
import { Translation } from './translations.model';

@Injectable({ providedIn: 'root' })
export class TranslationsFormTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                section: '', 
                default: '', 
                translation: ''
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'section';
    initialSortDirection = 'asc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    accesses = [];
    locales = [];
    hasFilter = false;
    languageId: string = "0";
    language: Translation;
    columns = [
                { prop: 'section', name: 'TRANSLATION.section', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'default', name: 'TRANSLATION.default', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'translation', name: 'TRANSLATION.translation', sortable: true, hasFilter: true, filter: "input"},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchFormRecords({id: this.languageId}));
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            section: '', 
            default: '', 
            translation: ''
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}